// Auto decimals: whole numbers show as 357,888 / 1,500,000 (no .00),
// fractions show 2 decimals (e.g. 53.10). Pass `decimals` to force.
export const formatMoney = (value, decimals = null) => {
  const num = Number(value) || 0;
  const d = decimals === null ? (Number.isInteger(num) ? 0 : 2) : decimals;
  return num.toLocaleString('en-PK', {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });
};

export const unwrapList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && data.data) return Array.isArray(data.data) ? data.data : [];
  if (key && data && data[key]) {
    const inner = data[key];
    if (Array.isArray(inner)) return inner;
    if (inner && Array.isArray(inner.data)) return inner.data;
    return [];
  }
  return [];
};

export const required = (value, label) => {
  if (value === undefined || value === null || String(value).trim() === '') {
    return `${label} is required`;
  }
  return '';
};

export const emailValid = (value) => {
  if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())) {
    return 'Enter a valid email address';
  }
  return '';
};

export const clearError = (errors, setErrors, field) => {
  if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
};

export const formatNumber = (value, decimals = 0) => {
  const num = Number(value) || 0;
  return num.toLocaleString('en-PK', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatDate = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toISOString ? value.slice(0, 10) : value;
};

// DD-MM-YYYY — used in PDF prints and Excel exports.
export const fmtDate = (value) => {
  if (!value) return '';
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return s.slice(0, 10);
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const date = d.toISOString().slice(0, 10);
  const time = d.toTimeString().slice(0, 5);
  return `${date} ${time}`;
};

export const today = () => new Date().toISOString().slice(0, 10);

export const currentMonth = () => today().slice(0, 7);

export const titleCase = (str = '') =>
  str
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const slugify = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const fileStamp = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let h = d.getHours();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${pad(d.getDate())}-${months[d.getMonth()]}-${d.getFullYear()}_${pad(h)}-${pad(d.getMinutes())}-${ampm}`;
};

export const labelify = (value) =>
  value
    ? value
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
    : value;